// workaround for mineflayer
process.versions.node = '18.0.0'
